module.exports = __webpack_public_path__ + "img/V-L-135-unload-standup-top.8f3d2184.png";